import React from "react";
import { useState } from "react";
import heroImg from "./../assets/png/hero.png";
import herotext from "./../assets/png/hero-text.png";
function Hero() {
  const [copied, setCopied] = useState(false);
  const textToCopy = "m6gG3z28NjKQn1GyEUjFEKTQnFmCeP2RLFYRphTJoSH";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  return (
    <>
      <div className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8  pt-40">
        <div className="flex flex-col md:flex-row items-center  2xl:gap-20 justify-between ">
          <div className="max-w-[400px] lg:max-w-[500px] xl:max-w-[607px] relative  md:pe-5 lg:pe-14 2xl:pe-0 pb-10 text-center md:text-start  ">
            <h1
              className="text-5xl sm:text-7xl  xl:text-[160px] 2xl:text-[200px] text-aircruiser xl:tracking-[-4px] text-shadow text-black relative"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              $JOSH{" "}
              <div className="absolute -top-20 lg:-top-28 xl:-top-28 2xl:-top-36  right-0 md:right-16 xl:-right-20 2xl:-right-48 max-w-[100px] lg:max-w-[150px] 2xl:max-w-[200px] ">
                <img src={herotext} alt="img" className="w-full" />
              </div>
            </h1>
            <p
              className="text-black text-base sm:text-lg lg:text-xl xl:text-[22px] my-4  xl:my-8"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              Josh, the strongest man on solana is here!{" "}
            </p>
            <p
              className="text-black mb-3 md:lg-5 xl:mb-6 text-aircruiser  text-lg sm:text-xl lg:text-[22px] xl:text-[26px]"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              CONTRACT ADDRESS
            </p>
            <div
              className="flex items-center gap-2 rounded-xl border border-black  shadow-[0px_6px_0px_0px_#000]  bg-white p-3 xl:p-5 pe-1.5 xl:pe-2.5 justify-between flex-nowrap max-w-[320px] sm:max-w-fit  "
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <p className="text-sm sm:text-base text-black text-ellipsis overflow-hidden  truncat">
                m6gG3z28NjKQn1GyEUjFEKTQnFmCeP2RLFYRphTJoSH
              </p>{" "}
              <button
                className="bg-[#00FFF4] border rounded-xl shadow-[-2px_4px_0px_0px_#000]  text-base md:text-lg lg:text-xl 2xl:text-2xl  px-5 md:px-8   py-1.5 xl:py-3   text-black text-aircruiser transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000]"
                onClick={handleCopy}
              >
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
            <div
              className="flex my-6 sm:my-8 xl:my-12 gap-3 sm:gap-4 xl:gap-6 flex-nowrap"
              data-aos="fade-up"
              data-aos-duration="3000"
            >
              <a
                href="https://dexscreener.com/solana/7suklvbqlkam7iyot6omjwqgtehwuy6wp58b5ofphg88"
                className="bg-[#0279E1] py-2.5 sm:py-3 xl:py-5 px-5 sm:px-6 xl:px-10 border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000] text-white text-lg sm:text-xl xl:text-2xl 2xl:text-[32px] text-aircruiser w-1/2 transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000]
              "
              >
                Buy $JOSH
              </a>
              <a
                href="https://josh-hero-03.netlify.app/"
                className="bg-white py-2.5 sm:py-3 xl:py-5 px-5 sm:px-6 xl:px-10 border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000] text-black text-lg sm:text-xl xl:text-2xl 2xl:text-[32px] text-aircruiser w-1/2 transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000] uppercase
              "
              >
                Play Now
              </a>
            </div>
          </div>
          <div className="max-w-[850px]    " data-aos="zoom-in">
            <img src={heroImg} alt="josh" className="w-full" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Hero;
